<template>
    <div class="col-12 nopads">
        <top-bar :current-view="views.MY_DONATIONS_VIEW"/>
        <alert
                :show="alertVisible"
                :message="message"
                :variant="variant"
                @alertShown=alertShown
        />
        <div class="col-12 main-container">
            <div class="col-xl-10 content-container mx-auto">
                <div class="col-12 nopads mt-6">
                    <b-container class="mb-3 pl-0 pr-0">
                      <b-col lg="12" class="no-gutters">
                        <h3>{{ activeTab === 1 ? $t('common.my_donations') : $t('common.my_subscriptions') }}</h3>
                      </b-col>
                    </b-container>
                    <!-- Tabs -->
                    <b-container class="pl-0 pr-0" >
                        <b-row class="mt-3 mb-4">
                            <div class="col-6 nopads fair-tab-container">
                                <div
                                        class="col-12 nopads fair-tab align-bottom"
                                        v-bind:class="{ active_tab: activeTab===1}"
                                        @click.stop="setView(1)">
                                    <span class="tab-title">Kertalahjoitukset</span>
                                </div>
                            </div>
                            <div class="col-6 nopads fair-tab-container align-bottom">
                                <div
                                        class="col-12 nopads fair-tab align-bottom"
                                        v-bind:class="{ active_tab: activeTab===2}"
                                        @click.stop="setView(2)">
                                    <span class="tab-title">{{ $t('common.my_subscriptions')}}</span>
                                </div>
                            </div>
                        </b-row>
                    </b-container>
                    <div v-if="activeTab === 1" class="col-12 pt-2">
                        <my-donations  @alert="showAlert"/>
                    </div>
                    <div v-if="activeTab === 2" class="col-12 pt-2">
                        <my-subscriptions @alert="showAlert"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {views} from "../mixins/ViewMixin"
    import TopBar from "../components/TopBar";
    import MyDonations from "../components/donation/MyDonations";
    import MySubscriptions from "../components/donation/MySubscriptions";
    import Alert from "../components/Alert";
    import {alertMixin} from "../mixins/AlertMixin";

    export default {
        name: "my-donations-view",
        mixins: [views, alertMixin],
        components: {Alert, MySubscriptions, MyDonations, TopBar},
        data() {
            return {
                views,
                activeTab: 1
            }
        },

        methods: {
            setView(tab) {
                this.activeTab = tab
            }
        }
    }
</script>

<style scoped>
</style>